<template>
  <!--<link href="./assets/fontawesome/css/fontawesome.css" rel="stylesheet" />
  <link href="./assets/fontawesome/css/solid.css" rel="stylesheet" />-->
  <router-view />
</template>

<style>
</style>
